import { render, staticRenderFns } from "./BasePreferences.vue?vue&type=template&id=597b5315&"
import script from "./BasePreferences.vue?vue&type=script&lang=ts&"
export * from "./BasePreferences.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('597b5315')) {
      api.createRecord('597b5315', component.options)
    } else {
      api.reload('597b5315', component.options)
    }
    module.hot.accept("./BasePreferences.vue?vue&type=template&id=597b5315&", function () {
      api.rerender('597b5315', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/Application/Sections/BasePreferences.vue"
export default component.exports